import { SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { BarChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/bar-chart';
import { LineChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart//line-chart';
import { AreaChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/area-chart';
import { PieChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/pie-chart';
import { DoughnutChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/doughnut-chart';
import { RadarChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/radar-chart';
import { ScatterChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/scatter-chart';
import { StockChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/stock-chart';
import { OfPieChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/of-pie-chart';
import { BubbleChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/bubble-chart';
import { ChartType } from '@src/slide/domain/ui-model/element-modeles/chart-models/migrate-v2-data';
import type { BaseSubChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/base-sub-chart';
import type { ISubChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';

// eslint-disable-next-line complexity
export function createSubChartModelByType(type: SubChartType, id: string): ISubChartModel | undefined {
    switch (type) {
        case SubChartType.BarChart:
        case SubChartType.Bar3DChart:
            return new BarChart(id);
        case SubChartType.LineChart:
        case SubChartType.Line3DChart:
            return new LineChart(id);
        case SubChartType.AreaChart:
        case SubChartType.Area3DChart:
            return new AreaChart(id);
        case SubChartType.PieChart:
        case SubChartType.Pie3DChart:
            return new PieChart(id);
        case SubChartType.DoughnutChart:
            return new DoughnutChart(id);
        case SubChartType.RadarChart:
            return new RadarChart(id);
        case SubChartType.ScatterChart:
            return new ScatterChart(id);
        case SubChartType.StockChart:
            return new StockChart(id);
        case SubChartType.OfPieChart:
            return new OfPieChart(id);
        case SubChartType.BubbleChart:
            return new BubbleChart(id);
    }
}

// eslint-disable-next-line complexity
export function getSubChartModelConstructorByType(chartType: ChartType):
(new (id: string) => (BaseSubChart | undefined))| undefined  {
    switch (chartType) {
        case ChartType.BAR:
        case ChartType.BAR_3D:
            return BarChart;
        case ChartType.LINE:
        case ChartType.LINE_3D:
            return LineChart;
        case ChartType.RADAR:
            return RadarChart;
        case ChartType.PIE:
        case ChartType.PIE_3D:
            return PieChart;
        case ChartType.DOUGHNUT:
            return DoughnutChart;
        case ChartType.AREA:
        case ChartType.AREA_3D:
            return AreaChart;
        case ChartType.SCATTER:
            return ScatterChart;
        case ChartType.BUBBLE:
            return BubbleChart;
        case ChartType.STOCK:
            return StockChart;
        case ChartType.OF_PIE:
            return OfPieChart;
    }
}

